import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Button,
  Divider,
  useTheme,
} from "@mui/material";
import { styled, useMediaQuery } from "@mui/system";
import { darkColors } from "../../../theme/colors";
import GradientButton from "../gradient-button";
import englishTranslations from "../../../i18n/translations/en";
import { Edit } from "@mui/icons-material";
import DashedButton from "../dashed-button";
import { assetIcons, assetImages } from "../../../constants/assets";
import { useUser } from "../../../context/user-context";
import InlineSvg from "../inline-svg";
import WalletPopup from "../popups/wallet-popup";
import ConfirmationModal from "../popups/confirmation-popup";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import useApiRequest from "../../../api/api";
import apiRoutes from "../../../api/routes";
export const AvatarWrapper = styled(Box)({
  position: "relative",

  width: "fit-content",
  "&:hover .edit-icon": {
    opacity: 0.8,
  },
});

const EditIconWrapper = styled(Box)({
  position: "absolute",
  right: -3,
  bottom: -3,
  background: "#161616",
  border: "1px solid",
  borderRadius: "99%",
  borderColor: darkColors.buttonTop,
  height: 23,
  width: 23,
  paddingInline: 0,
  // cursor: "pointer",
  opacity: 1,
  transition: "opacity 0.2s",
});

export const UserProfile = () => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { user, updateUser } = useUser();
  const [openWalletModal, setIsOpenWalletModal] = useState(false);
  const [currentTab, setCurrentTab] = useState("topup");
  const [open, setOpen] = useState(false);
  const { makeApiCall } = useApiRequest();

  const handleOpen = () => {
    setOpen(true);
  };

  // To close the modal
  const handleClose = () => {
    setOpen(false);
  };
  const hanldeWalletOpen = () => {
    setIsOpenWalletModal(true);
  };
  const handleTopupClick = () => {
    setCurrentTab("topup");
    hanldeWalletOpen();
  };
  const handleWithdrawClick = () => {
    setCurrentTab("withdraw");
    hanldeWalletOpen();
  };
  const handleRemoveWalletClick = async () => {
    const response = await makeApiCall(
      apiRoutes.wallet.remove(user.wallet.identifier),
      "DELETE",
      null,
      "show"
    );
    if (response.success) {
      const updatedUser = {
        ...user,
        wallet: null,
      };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      updateUser(updatedUser);
    }
    handleClose();
  };
  return (
    <Box
      bgcolor={darkColors.userProfileBg}
      mt={isMediumScreen ? 0 : 3}
      p={3}
      borderRadius={"16px"}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <AvatarWrapper>
          <Avatar
            src={user?.imageURL}
            // alt="show"
            sx={{
              width: 57,
              height: 57,
              border: "2px solid",
              borderColor: darkColors.buttonTop,
            }}
          />
        </AvatarWrapper>
        <Box>
          <Typography
            sx={{
              color: "white",
              fontSize: "16px",
              fontWeight: 500,
              textAlign: "left",
            }}
          >
            {user?.displayName}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                bgcolor: "#FF6B00",
              }}
            />
            <Typography
              sx={{
                color: "white",
                fontSize: "14px",
                ml: 1,
              }}
            >
              Online
            </Typography>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ background: darkColors.gray }} />
      <Box
        sx={{
          mb: 2,
          mt: 2,
          background: darkColors.gray,
          height: 50,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingInline: 2,
          borderRadius: "12px",
        }}
      >
        <Typography color="white">Balance:</Typography>
        <Typography display={"flex"} color="white">
          <InlineSvg url={assetIcons.currencyIcon} sx={{ mr: 0.5, mt: 0.2 }} />
          {/* <Box component={"img"} src={assetIcons.currencyIcon} />  */}
          {user?.walletAmount ? user.walletAmount : 0}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <GradientButton
          text={englishTranslations.home.topupButton}
          onClick={handleTopupClick}
          width={isMediumScreen ? "50%" : "200px"}
          variant="contained"
          py={0.8}
          disabled={!user?.wallet}
        />
        <GradientButton
          text={englishTranslations.home.withdrawButton}
          onClick={handleWithdrawClick}
          width={isMediumScreen ? "50%" : "200px"}
          variant="outlined"
          py={0.8}
          fontVariant="bold"
          disabled={!user?.wallet}
        />
      </Box>
      {user?.wallet && (
        <DashedButton
          icon={<RemoveOutlinedIcon />}
          text={englishTranslations.home.removeWalletButton}
          backgroundColor={darkColors.pagesBgTop} // Custom background color
          width={isMediumScreen ? "100%" : "270px"}
          padding="10px 10px"
          onClick={handleOpen}
        />
      )}

      <WalletPopup
        open={openWalletModal}
        onClose={() => setIsOpenWalletModal(false)}
        currentTab={currentTab}
      />
      <ConfirmationModal
        open={open}
        onClose={handleClose}
        img={assetImages.warning} // Dynamic image source
        title="Remove Wallet"
        message="Are you sure you want to remove your connected wallet?"
        confirmButtonText="REMOVE"
        closeButtonText="Cancel"
        handleSubmit={handleRemoveWalletClick} // Action to be executed on confirm
        secondaryClick={handleClose}
      />
    </Box>
  );
};
